export default "__VITE_ASSET__gJf6oUGo__"